import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { appFeature } from '@access-request-unicorn/state/app.reducer';

export const CanActivateConfirmation: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(appFeature.selectRequestSent).pipe(
    map(sent => sent || router.createUrlTree(['summary']))
  );
}
